import { ArrowDropDown, AdminPanelSettings, Logout } from '@mui/icons-material'
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material'
import { MouseEvent, useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import './header.css'
import AuthContext from 'contexts/AuthContext'

export default function Header() {
  const { username, isStaff } = useContext(AuthContext)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseUserMenu = (key: string) => {
    if (key === 'logout') {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('username')
      window.location.href = `${process.env.REACT_APP_LOGIN_URL}/login`
    }
    setAnchorEl(null)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box className="header-box">
      <Box className="header-box-left">
        <Typography component={Link} to={process.env.REACT_APP_LOGIN_URL ?? '/'} id="header-title">
          veracity<span>OE</span>
        </Typography>
        <Box border={'1px solid #FFFFFF'} height={'19.53px'} />
        <Typography component={Link} to={'/'} id="header-menu-title">
          Home
        </Typography>
        <Typography component={Link} to={'/'} id="header-menu-title">
          Projects
        </Typography>
      </Box>
     <Box className="header-box-right">
        <Button endIcon={<ArrowDropDown style={{ color: 'white' }} />} onClick={handleOpenUserMenu}>
          <Typography id="username-title" color={'#F5F7FF'}>
            {username}
          </Typography>
        </Button>
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {isStaff && <MenuItem sx={{ width: '180px', justifyContent: 'flex-start', gap: '8px' }} 
        >
          <AdminPanelSettings sx={{ fontSize: '20px' }} />
          <Typography variant="body2DMSans" component={'a'} href={'/admin'} target="_blank" sx={{ color: '#000000ff', textDecoration: 'none'}}>
            Admin
          </Typography>
        </MenuItem>
        }
        <MenuItem
          sx={{ width: '180px', justifyContent: 'flex-start', gap: '8px' }}
          onClick={() => handleCloseUserMenu('logout')}
        >
          <Logout sx={{ fontSize: '20px' }} />
          <Typography variant="body2DMSans">Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  )
}
